import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    html {
    -webkit-text-size-adjust: none !important;
      -ms-text-size-adjust: none !important;
      text-size-adjust: none !important;
    }
    
    body {
        line-height: 1;
        background: var(--cinza);
    }
  
    .modal-open {
        overflow: hidden;
    }

    img {
        width: inherit;
    }

    input, textarea, select {
        border: none;
        color: inherit;
        font-size: inherit;
        font-weight: inherit;
        font-family: inherit;
    }

    /* Estilos Globais */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: sans-serif;
    }

    *::-webkit-scrollbar {
        width: 6px;
    }

    *::-webkit-scrollbar-thumb {
        background: var(--degrade);
        border-radius: 10px;
    }

    :root {
        --cor-primaria: #3CBF3B;
        --cor-secundaria: #77c14b;
        --cor-contraste: #104A10;
        --cor-hover: #0A7EFF;
        --cor-hoverHome: #0A7EFF;
        --cor-infor:rgb(39, 119, 211);
        --cor-cinza: #E9E9E9;
        --fundo-poco:rgba(229, 229, 229, 0.64);
        --dark-barckground: radial-gradient(circle,rgb(45, 45, 45) 0%, rgb(39, 39, 39) 60%);;
        --shadow:rgba(0, 0, 0, 0.5);
        --branco: #FFFFFF;
        --cinza: radial-gradient(circle, rgba(255, 255, 255, 1) 50%, rgba(213, 213, 213, 1) 99%);
        --cor-erro: #9A1B00;
        --cor-hoverErro: #ED3F19;
        --liquido: #858b13;
        --alerta: red;
        --offline: red;
        --online:rgba(67, 225, 4, 1);
        --desligado: #60abff;
        --ligado: green;
        --degrade: radial-gradient(circle,#528535  80%, #104A10 130%);
        --app-safe-top: 0px;
        --app-safe-bottom: 0px;
    }

    @media (max-width: 800px) {
      :root {
        /* O fallback protege também WebViews Android em modo tela cheia. */
        --app-safe-top: max(28px, env(safe-area-inset-top, 0px));
        --app-safe-bottom: env(safe-area-inset-bottom, 0px);
      }

      body {
        margin-bottom: 0;
      }
    }

    @keyframes blink {
    0% {background-color: red;}
    50% { background-color: transparent; }
    100% {background-color: red;}
    }

    .blink {
    animation: blink 0.5s infinite;
    }

    @keyframes myAnim {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes alertAnim {
        0% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes giroBomba {

      0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
    }

    
@keyframes wave {
  0%   { transform: translateX(0); }
  50%  { transform: translateX(-35%); }
  100% { transform: translateX(0); }
}


@-webkit-keyframes tracking-in-expand {
  0% {
    letter-spacing: -0.5em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@keyframes tracking-in-expand {
  0% {
    letter-spacing: -0.5em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

`;
